import type { WithLocalPetitionPhoto } from '#src/app/pages/homepage/shared/utils';
import { getLocalPetitionCardImageUrl } from '#src/app/pages/homepage/shared/utils';

type BuildLocationSlugParam = { city: string; stateCode: string; countryCode: string };
export function buildLocationSlug({ city, stateCode, countryCode }: BuildLocationSlugParam): string {
	return `${city}--${stateCode}--${countryCode}`.toLowerCase().replace(/\s+/g, '');
}

/**
 * Petitions with a usable card image first, the rest after, each group keeping its trending
 * order. The section renders only the first few of what we fetch, so this fills those slots
 * with photos where it can without dropping anything - a location whose trending petitions
 * all lack photos still gets a full section, just an image-less one.
 */
export function sortByCardImageFirst<T extends WithLocalPetitionPhoto>(petitions: readonly T[]): readonly T[] {
	const hasImage = (petition: T) => !!getLocalPetitionCardImageUrl(petition);

	return [...petitions.filter(hasImage), ...petitions.filter((petition) => !hasImage(petition))];
}
